import { createFileRoute } from "@tanstack/react-router";
import { Page, SectionEyebrow, CTAButton } from "@/components/SiteLayout";
import wijzen from "@/assets/wijzen.jpeg.asset.json";

export const Route = createFileRoute("/tarieven")({
  head: () => ({
    meta: [
      { title: "Tarieven — Hi Coach" },
      { name: "description", content: "Kies jouw startpunt: Hi Instap, Hi Sprong, Hi Groei of Hi Held. Start met een gratis proefles." },
      { property: "og:title", content: "Hi Coach Tarieven" },
      { property: "og:description", content: "Gratis proefles plus vier pakketten vanaf €40 per maand." },
      { property: "og:url", content: "/tarieven" },
    ],
    links: [{ rel: "canonical", href: "/tarieven" }],
  }),
  component: Tarieven,
});

function Tarieven() {
  const plans = [
    { name: "Hi Instap", desc: "1 lessenreeks van 1 thema (7 lessen)", total: "€ 100,-", termijn: "2 maandelijkse termijnen (sept & okt)", month: "€ 50,-", color: "#FF8080" },
    { name: "Hi Sprong", desc: "Pakket van 2 thema's (14 lessen)", total: "€ 180,-", termijn: "4 maandelijkse termijnen (sept t/m dec)", month: "€ 45,-", color: "#FFEB80" },
    { name: "Hi Groei", desc: "Pakket van 3 thema's (21 lessen)", total: "€ 255,-", termijn: "6 maandelijkse termijnen (sept t/m feb)", month: "€ 42,50", color: "#FFB87F", badge: "Aanbevolen" },
    { name: "Hi Held", desc: "De ultieme sportreis: alle 5 de thema's (35 lessen) inclusief het grote diplomafeest.", total: "€ 400,-", termijn: "10 maandelijkse termijnen (sept t/m juni)", month: "€ 40,00", color: "#8FC7FF" },
  ];
  return (
    <Page>
      <section className="pt-24 pb-10 bg-white">
        <div className="mx-auto max-w-4xl px-6">
          <SectionEyebrow color="var(--rb-orange)">Tarieven</SectionEyebrow>
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight">
            Kies jouw startpunt: <span style={{ color: "var(--rb-orange)" }}>Lessenpakketten &amp; Tarieven</span>
          </h1>
          <div className="mt-6 space-y-4 text-lg text-muted-foreground">
            <p>
              Samen op avontuur, rennen met een lach, voor de mooiste rode wangetjes van de dag! Elke zondag klimmen we hoog, rollen we in het rond en blijven we fit en gezond.
            </p>
            <p>
              Bij ons staat persoonlijke aandacht centraal. Onze groepen zijn bewust klein met maximaal twaalf kinderen. Daarnaast duren onze lessen een vol uur en dus geen 45 minuten, zoals je bij andere aanbieders vaak ziet. Vol is wel echt vol!
            </p>
            <p>
              Ons jaarprogramma bestaat uit 35 lessen, verdeeld over 5 herkenbare schoolthema's van elk 7 weken. Op zondag 5 juli sluiten we het jaar feestelijk af met een groot diplomafeest!
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="mx-auto max-w-7xl px-6">
          <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
            {plans.map((p) => (
              <div key={p.name} className="relative rounded-3xl p-7 shadow-xl flex flex-col border-t-8 bg-white" style={{ borderTopColor: p.color, color: "#1a1a1a" }}>
                {p.badge && (
                  <span className="absolute -top-3 right-6 bg-foreground text-white text-xs font-extrabold uppercase tracking-wider px-3 py-1 rounded-full">{p.badge}</span>
                )}
                <h3 className="text-2xl font-extrabold">{p.name}</h3>
                <p className="mt-3 text-sm flex-1">{p.desc}</p>
                <p className="mt-4 text-sm"><span className="font-extrabold">Totaal:</span> {p.total}</p>
                <p className="mt-1 text-sm">{p.termijn}</p>
                <p className="mt-4 text-3xl font-extrabold">{p.month}<span className="text-sm font-bold"> /mnd</span></p>
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm text-muted-foreground max-w-3xl mx-auto text-center">
            Alle pakketten zijn exclusief het Hi Coach Club sportshirtje, aan te schaffen bij inschrijving.
          </p>
          <div className="mt-8 max-w-3xl mx-auto text-sm text-muted-foreground space-y-3">
            <p>
              Bij inschrijving is het officiële Hi Coach Club sportshirtje verplicht. Je kiest direct je maat; de kosten hiervan zijn inbegrepen in de eenmalige inschrijfkosten van € 49,95. Het gekozen maandbedrag wordt aan het einde van elke maand automatisch afgeschreven. Alle lespakketten zijn exclusief het officiële Hi Coach Club sportshirtje bij inschrijving.
            </p>
            <p className="font-extrabold text-foreground">Entertainment en ontwikkeling voor jouw kind</p>
            <p>
              Voor een vast maandbedrag geef je jouw peuter of kleuter een ticket voor het leukste beweegavontuur van de week. Een waardevolle investering in structureel plezier waar ze sterker, zelfverzekerder en fitter van worden!
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white text-center">
        <div className="mx-auto max-w-2xl px-6 flex flex-col items-center">
          <img src={wijzen.url} alt="Enthousiast kind wijst omhoog" className="w-56 md:w-72 h-auto mb-6" loading="lazy" />
          <h2 className="text-3xl md:text-4xl font-extrabold">Klaar om te starten?</h2>
          <div className="mt-6"><CTAButton>Schrijf je nu in</CTAButton></div>
        </div>
      </section>
    </Page>
  );
}
